import request from '../utils/request';

export const goodsApi = {
  /**
   * 分页查询商品
   * @param {Object} params - 查询参数
   * @param {number} params.page - 页码
   * @param {number} params.pageSize - 每页条数
   * @param {Object} params.queryParams - 查询条件
   * @returns {Promise} 商品分页数据
   */
  pageGoods: (params) => {
    return request({
      url: '/goods/page',
      method: 'get',
      params: {
        page: params.page || 1,
        pageSize: params.pageSize || 10,
        ...params.queryParams
      }
    });
  },

  /**
   * 添加商品
   * @param {Object} data - 商品数据
   * @returns {Promise} 添加结果
   */
  addGoods: (data) => {
    return request({
      url: '/goods/add',
      method: 'post',
      data: {
       
          uid: data.uid || null,
          name: data.name,
          categoryId: data.categoryId,
          price: data.price,
          originalPrice: data.originalPrice || null,
          stock: data.stock,
          salesVolume: data.salesVolume || 0,
          description: data.description || null,
          status: data.status || 'ON_SHELF',
          auditStatus: data.auditStatus || 'PENDING',
          auditTime: data.auditTime || null,
          auditAdminId: data.auditAdminId || null,
          auditReason: data.auditReason || null
       
      }
    });
  },

  /**
   * 更新商品
   * @param {Object} data - 商品数据
   * @returns {Promise} 更新结果
   */
  updateGoods: (data) => {
    return request({
      url: '/goods/update',
      method: 'put',
      data: {
     
          id: data.id,
          uid: data.uid || null,
          name: data.name,
          categoryId: data.categoryId,
          price: data.price,
          originalPrice: data.originalPrice || null,
          stock: data.stock,
          salesVolume: data.salesVolume || 0,
          description: data.description || null,
          status: data.status || 'ON_SHELF',
          auditStatus: data.auditStatus || 'PENDING',
          auditTime: data.auditTime || null,
          auditAdminId: data.auditAdminId || null,
          auditReason: data.auditReason || null
      }
    });
  },

  /**
   * 删除商品
   * @param {number} goodsId - 商品ID
   * @returns {Promise} 删除结果
   */
  deleteGoods: (goodsId) => {
    return request({
      url: `/goods/${goodsId}`,
      method: 'delete'
    });
  }
};

export default goodsApi; 